const restaurant = {
  restaurant: "レストラン", // translated
  restaurants: "レストラン", // translated
  category: "カテゴリー", // translated
  score: "スコア", // translated
  priceQuartile: "価格の四分位", // translated
  scoreLowestFirst: "スコア（低い順）", // translated
  scoreHighestFirst: "スコア（高い順）", // translated
  priceLowestFirst: "価格（安い順）", // translated
  priceHighestFirst: "価格（高い順）", // translated
  allPrices: "すべての価格", // translated
  reserve: "予約する", // translated
  dining: "ダイニング", // translated
};


export default restaurant;
